export default [
  //  deliveries  router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "deliveries",
      layout: "dashboard",
    },
    path: "/deliveries",
    name: "deliveries",
    component: () => import("@/layouts/index/DeliveryIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "deliveries **",
          layout: "dashboard",
        },
        path: "index",
        name: "deliveries-index",
        component: () => import("@/views/deliveries/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Effectué et enregistre la commande",
          layout: "dashboard",
        },
        path: "create",
        name: "deliveries-create",
        component: () => import("@/views/deliveries/Create.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Effectué et enregistre la commande",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "deliveries-details",
        component: () => import("@/views/deliveries/Details.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Effectué et enregistre la commande",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "deliveries-edit",
        component: () => import("@/views/deliveries/Edit.vue"),
      },
    ],
  },
];
